module.exports = __webpack_public_path__ + "img/ic03.8d86878c.png";